/**
 * Translate the Tek Labs free-gift notification.
 *
 * The app falls back to English when no translation is saved for Shopify.locale.
 * This wraps its popup class so the theme locale strings are used, and rewrites
 * any banner that still shows the English defaults.
 *
 * Expects window.pokecccTeklabsNotification from the Liquid snippet.
 */
(function () {
  'use strict';

  var ENGLISH_HEADERS = {
    'Free gift': true,
    'Congratulations! You’ve unlocked a reward 🎉': true,
    "Congratulations! You've unlocked a reward 🎉": true,
  };
  var ENGLISH_BODY = 'Your free gift is now in your cart.';

  function config() {
    return window.pokecccTeklabsNotification || null;
  }

  function localeKeys() {
    var cfg = config();
    var keys = [];

    function add(code) {
      if (!code) return;
      var value = String(code);
      if (keys.indexOf(value) === -1) keys.push(value);
      var base = value.split('-')[0];
      if (base && keys.indexOf(base) === -1) keys.push(base);
    }

    if (cfg && cfg.locale) add(cfg.locale);
    if (window.Shopify && window.Shopify.locale) add(window.Shopify.locale);
    if (!keys.length) keys.push('en');
    return keys;
  }

  function withLocale(translations) {
    var cfg = config();
    if (!cfg || !cfg.header || !cfg.body) return translations;

    var copy;
    try {
      copy = translations && typeof translations === 'object' ? JSON.parse(JSON.stringify(translations)) : {};
    } catch (error) {
      copy = {};
    }
    if (!copy.notification || typeof copy.notification !== 'object') copy.notification = {};

    localeKeys().forEach(function (key) {
      var existing = copy.notification[key];
      var hasText =
        existing &&
        typeof existing === 'object' &&
        (existing.header_text || existing.body_text);
      if (hasText) return;
      copy.notification[key] = {
        header_text: cfg.header,
        body_text: cfg.body,
      };
    });

    return copy;
  }

  function wrap(Original) {
    if (typeof Original !== 'function' || Original.__pokecccWrapped) return Original;

    function Wrapped(isRestricted, displaySettings, translations) {
      return new Original(isRestricted, displaySettings, withLocale(translations));
    }

    Wrapped.prototype = Original.prototype;
    Wrapped.__pokecccWrapped = true;
    return Wrapped;
  }

  function installTrap() {
    if (window.__pokecccTeklabsNotificationTrap) return;
    window.__pokecccTeklabsNotificationTrap = true;

    var current = window.tlNotificationPopupClass;
    Object.defineProperty(window, 'tlNotificationPopupClass', {
      configurable: true,
      enumerable: true,
      get: function () {
        return current;
      },
      set: function (value) {
        current = wrap(value);
      },
    });

    if (current) current = wrap(current);
  }

  function polish(root) {
    var cfg = config();
    if (!cfg || !root || !root.querySelectorAll) return;

    root.querySelectorAll('.salepify-notification-popup__header').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (ENGLISH_HEADERS[text] && text !== cfg.header) el.textContent = cfg.header;
    });

    root.querySelectorAll('.salepify-notification-popup__body').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === ENGLISH_BODY && text !== cfg.body) el.textContent = cfg.body;
    });

    root.querySelectorAll('.salepify-notification-popup__close-btn').forEach(function (el) {
      if (cfg.close && !el.getAttribute('aria-label')) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', cfg.close);
      }
    });
  }

  function observe() {
    if (window.__pokecccTeklabsNotificationObserver || !document.documentElement) return;
    polish(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            node.matches &&
            (node.matches('.salepify-notification-popup, .salepify-notification-popup-container') ||
              node.querySelector('.salepify-notification-popup'))
          ) {
            polish(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.__pokecccTeklabsNotificationObserver = observer;
  }

  installTrap();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
